import { normalize } from 'normalizr';

import * as schemas from 'schemas';
import { callApi } from 'utils/api';

export function userReferrersFetch() {
  return callApi('/user/referrers');
}

export function userEthnicitiesFetch() {
  return callApi('/user/ethnicities');
}

export function userLocalAuthoritiesFetch() {
  return callApi('/user/local-authorities');
}

export function userLocationsFetch(location) {
  return callApi('/user/location', {
    query: {
      location
    }
  });
}

export function userAvatarsFetch() {
  return callApi('/user/avatars')
  .then(json => {
    const { result, entities } = normalize(json, schemas.userAvatarsArraySchema);

    return {userAvatarIds: result, entities};
  });
}

export function userSignupQuestionnaireFetch(LAID) {
  return callApi('/user/registration/questionnaire', {
    query: {
      LAID
    }
  });
}

export function userVerifyEmail(email) {
  return callApi('/user/email-verification', {
    query: {
      email
    }
  });
}

export function userValidateToken(token) {
  return callApi('/user/validate-token', {
    query: {
      token
    }
  });
}

export function userCheckUsername(userName) {
  return callApi('/user/check-username', {
    query: {
      userName
    }
  });
}

export function userCheckPassword(passWord) {
  return callApi('/user/check-password', {
    query: {
      passWord
    }
  });
}

export function userUpdate(updates) {
  return callApi('/user', {
    method: 'PATCH',
    body: {
      ...updates
    }
  });
}

export function userCreate({
  userName,
  passWord,
  sublocationId,
  sex,
  ethnicity,
  yearOfBirth,
  monthOfBirth,
  referrer,
  startYear,
  startMonth,
  endYear,
  endMonth,
  token,
  questionnaire
}) {

  const body = {
    userName,
    passWord,
    sublocationId,
    sex,
    ethnicity,
    yearOfBirth,
    monthOfBirth,
    referrer
  };

  if (startYear !== undefined) body.startYear = startYear;
  if (startMonth !== undefined) body.startMonth = startMonth;
  if (endYear !== undefined) body.endYear = endYear;
  if (endMonth !== undefined) body.endMonth = endMonth;
  if (token !== undefined) body.token = token;
  if (typeof questionnaire === Object) body.questionnaire = questionnaire;

  return callApi('/user', {
    method: 'POST',
    body: body
  });
}



/** WEBPACK FOOTER **
 ** ./src/members/state/user/api.js
 **/